<script>
		import { user, view, change_attribute } from "../client.svelte.js";
		import {protoTraits, fieldLabels} from "../core.js";
		import Output from "../elements/Output.svelte";
		import Sheet from "./Sheet.svelte";
		import Sidebar from "../elements/Sidebar.svelte";
		import {note, pips, signed} from "./SheetFields.svelte";

		let { disabled = true } = $props()

		const maxPrimeSum = 12
		const traitCats = {prime: "Primäre Eigenschaften", social: "Soziale Sekundär-Eigenschaften",
                       extrin: "Extrinsische Sekundär-Eigenschaften", intrin: "Intrinsische Sekundär-Eigenschaften"}

		let grpTraits = $derived(
			Object.groupBy(
				protoTraits
					.map(trait => (user.traits.has(`${view.character.ID}.${trait.ID}`))
						? user.traits.get(`${view.character.ID}.${trait.ID}`)
						: {TYPE: 'Trait', CHAR: view.character.ID, TRAIT: trait.ID, cat: trait.cat, value: null, comment: ""})
			, trait => trait?.cat))

		let sum = $derived((grpTraits['prime'] ?? []).reduce((sum, trait) => sum + (trait.value ?? 0), 0))
		let warn = $state("")

		// $inspect(`TRAITSSHEET – grpTraits`, grpTraits)

		/** sets trait to value (−4 … +4); primary traits must not exceed a total of 12 **/
		function set_value(trait, value) {
				if (value === (trait.value ?? 0))  return
				if (trait.cat === 'prime' && sum - (trait.value ?? 0) + value > maxPrimeSum) {
						warn = `Die Summe der primären Eigenschaften darf ${maxPrimeSum} nicht übersteigen.`
						return
				}
				warn = ""
				console.log(`TRAITS - change trait ${trait.TRAIT} to ${value}`)
				change_attribute.bind(trait)({target: {id: 'value', value}})
    }
</script>


<!-------------------------------- HTML -------------------------------------->

<section id='traits'>

	<Sidebar/>

	<Sheet {warn}>
		{#snippet stat()}
			<div class="prime-sum" data-help="allocation">
				<div class="kicker">Summe primär</div>
				<div class="prime-sum-value num" class:over={sum > maxPrimeSum}>{sum}<span class="prime-sum-max"> / {maxPrimeSum}</span></div>
			</div>
		{/snippet}

		{#each Object.keys(traitCats) as cat}
			<fieldset class="sheet-section" data-help={(cat === 'prime') ? 'primary' : 'secondary'}>
				<h2 class="sheet-title">{traitCats[cat]}</h2>
				<div class="traits-table">
					<span class="kicker colhead">Eigenschaft</span>
					<span class="kicker colhead center">{cat === 'prime' ? "Kürzel" : ""}</span>
					<span class="kicker colhead center" style="font-size: 110%">{#if cat === 'prime'}–4 · 0 · +4{:else}–3 · 0 · +3{/if}</span>
					<span class="kicker colhead center">Wert</span>
					<span class="kicker colhead">Erläuterung</span>
					{#each grpTraits[cat] ?? [] as trait}
						<a id={trait.TRAIT} class="cell trait-name" >{fieldLabels[trait.TRAIT] ?? trait.TRAIT}</a>
						<span class="cell abbr center">{cat === 'prime' ? trait.TRAIT : ""}</span>
						<span class="cell center" data-help={trait.TRAIT}>{@render pips({value: trait.value, disabled, onselect: (value) => set_value(trait, value)})}</span>
						<span class="cell trait-value num center" data-help={trait.TRAIT}>{signed(trait.value ?? 0)}</span>
						<span class="cell comment">{@render note({value: trait.comment, disabled, onchange: change_attribute.bind(trait)})}</span>
					{/each}
				</div>
			</fieldset>
		{/each}
	</Sheet>
</section>

<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.sum-box
		margin: 1ch
		padding: 12px
		display: grid
		grid-template-columns: auto 6ch
		gap: 8px 2ch
		align-items: center
		background: colors.$grey-15
		border: 1px solid colors.$grey-20

	.sum-hint
		grid-column: 1 / -1
		font-size: 12px
		color: colors.$grey-60

	.prime-sum
		text-align: right

	.prime-sum-value
		font-family: var(--font-heading)
		font-size: 34px
		line-height: 1.1

		&.over
			color: colors.$highlight-red-100

	.prime-sum-max
		font-size: 22px
		color: var(--color-neutral-600)

	.traits-table
		display: grid
		grid-template-columns: minmax(150px, 200px) 60px 230px 56px minmax(0, 1fr)
		column-gap: 24px

	.trait-name
		font-size: 16px

	.trait-value
		padding: 4px 0
		font-family: var(--font-heading)
		font-size: 26px
		line-height: 1.2

	.comment
		padding: 0
</style>
